import { useQuery } from "react-query";
import { listClinicUpdateRequests } from "src/components/Templates/api";
import PendingUpdateRequests from "./PendingUpdateRequests";
import Loader from "src/components/Dashboard/common/Loader";
import ApprovedRequests from "./ApprovedRequests";

const ClinicUpdate = () => {
    const { data, isLoading, isFetching, refetch } = useQuery(["clinic-update-requests"], listClinicUpdateRequests);

    const items = data?.items ?? [];
    const pendingRequests = items.filter(item => item.status?.toLowerCase() === "pending");
    const approvedRequests = items.filter(item => item.status?.toLowerCase() === "approved");

    return (
        <div className="w-100">
            <Loader show={isLoading || isFetching} />
            <PendingUpdateRequests
                data={pendingRequests}
                totalCount={data?.totalCount}
                refetch={refetch}
            />
            <ApprovedRequests data={approvedRequests} />
        </div>
    )
}

export default ClinicUpdate;